<template>
    <v-row>
        <v-col cols="12">
            <v-card flat align="center" class="card dt-border">
                <v-row align="center">
                    <v-col cols="12" md="3">
                        <p class="mb-0">wallet</p>
                    </v-col>
                    <v-col cols="12" md="2">
                      <p class="mb-0">status</p>
                    </v-col>
                    <v-col cols="12" md="2">
                        <p class="mb-0">confirmation charge</p>
                    </v-col>
                    <v-col cols="12" md="2">
                        <p class="mb-0">Charge Percentage</p>
                    </v-col>
                    <v-col v-if="can('can_alter_crypto_manager')"  cols="12" md="1">
                        <p class="mb-0">Edit</p>
                    </v-col>
                   
                    <v-col v-if="can('can_alter_crypto_manager')" cols="12" md="1">
                      <p class="mb-0">Action</p>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
        <v-col v-for="detail in coins" :key="detail.id" cols="12">
            <v-card flat align="center" class="card dt-border">
                <v-row align="center">
                    <v-col cols="12" md="3">
                        <div class="logo-container">
  <img :src="detail.logoURL" alt="Your Logo">
  <span class="logo-text">{{ detail.coinShortName }}</span>
</div>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-chip v-if="detail.isAvailable == true" :title="detail.isAvailable" color="accent">
                            activated
                        </v-chip>
                        <v-chip v-if="detail.isAvailable == false" :title="detail.isAvailable">
                            deactivated
                        </v-chip>
                    </v-col>
                    <v-col cols="12" md="2">
                        <p class="mb-0">{{ detail.postChargeAmount }}</p>
                    </v-col>
                    <v-col cols="12" md="2">
                        <p class="mb-0">{{ detail.postChargePercentage }}</p>
                    </v-col>
                    <v-col v-if="can('can_alter_crypto_manager')" cols="12" md="1">
                        <p class="mb-0"> <EditConfirmChangeModal :coin="detail"></EditConfirmChangeModal></p>
                    </v-col>
                   
                    <v-col v-if="can('can_alter_crypto_manager')" cols="12" md="1">
                        <v-menu  :close-on-content-click="true" bottom right>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" icon>
                                    <v-icon>
                                        mdi-dots-vertical
                                    </v-icon>
                                </v-btn>
                            </template>

                            <v-list>
                            

                                <v-list-item-title>
                                    <v-list-item  link>
                                        <v-list-item-title @click="toggleCoin(detail,true  )">
                                            Activate
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list-item-title>

                                <v-list-item link>
                                    <v-list-item-title @click="toggleCoin(detail,false  )">
                                        Deactivate
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                            
                        </v-menu>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
        <audit-modal :detail="detail" @closeModal=" dialog = false" :dialog="dialog" />
    </v-row>
</template>

<script>

import { CryptoService  } from "@/services";


import app from '@/main'



import EditConfirmChangeModal from './edit-confirmation-charges.vue';
import { parseTimestamp } from '@/utils/dates';
export default {
    props:{
        coins:{
            type:Array
        }
    },
    data:() =>({
        dialog : false,
        detail : {},
        lowerRange: 0,
    }),
    components:{
        EditConfirmChangeModal
    },
    computed:{
        
    },
    methods:{
        formatDate(date){
            let d = new Date(date)
            let reModelDate = d.toLocaleString(["en-Us"], {
                month: "short",
                day: "2-digit",
                year: "numeric",
            });
            return reModelDate;
        },
        formatTime(time){
            return parseTimestamp(new Date(time), 'HH:mm');
        },
         status(color){
            let data;
            if(color == "successful"){
                data = "success"
            }
            else if(color == "failed"){
                data = "error"
            }
            return data
        },
        viewlog(detail){
            this.detail = detail;
            this.dialog = true;
        },
        async toggleCoin(coin, action){
            coin.isAvailable = action;
            let uploadCoin = {};
            uploadCoin.id = coin.id;
            uploadCoin.isAvailable = coin.isAvailable;
            let data = await CryptoService.updateCoin(uploadCoin);
            if(data){
                app.$store.dispatch('toast', {
          message: `the coin has been ${action ? 'activated': 'deactivated'}`,
          variant: 'success'
        })
                this.coins.forEach((c,i)=>{
                if(c.id == coin.id) return this.coins[i].isAvailable = action;
            })
            }
            
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../styles.scss';
small{
    color: #656565;
    font-weight: 600;
    text-decoration: underline;
}
.logo-container {
  display: flex;
  align-items: center;
}

.logo-container img {
  margin-right: 10px; 
  width: 20px;
  height: 20px;
  /* add margin if necessary */
}

.logo-text {
  font-size: 18px; /* adjust font size as needed */
}
</style>